import { useCallback } from "react";

import { useFastshiftAnalyticsData, useFireAnalyticsEvents } from "@/analytics";
import {
    ActionKey,
    ActionSubjectKey,
    ActionSubjectIdKey
} from "@/analytics/constants";

export const useRelationshipsAnalytics = () => {
    const { sourceKey, identityAttrs } = useFastshiftAnalyticsData(true);
    const { fireUIEvent, fireTrackEvent } =
        useFireAnalyticsEvents(identityAttrs);

    const sendRequestAssistanceButtonClickUIEvent = useCallback(() => {
        fireUIEvent({
            action: ActionKey.CLICKED,
            actionSubject: ActionSubjectKey.BUTTON,
            actionSubjectId: ActionSubjectIdKey.REQUEST_ASSISTANCE_BUTTON,
            source: sourceKey
        });
    }, [fireUIEvent, sourceKey]);

    const sendRequestAssistanceModalCommentSubmitButtonClickUIEvent =
        useCallback(
            (supportTicketId: string) => {
                fireUIEvent({
                    action: ActionKey.CLICKED,
                    actionSubject: ActionSubjectKey.BUTTON,
                    actionSubjectId:
                        ActionSubjectIdKey.REQUEST_FASTSHIFT_ASSISTANCE_MODAL_SUBMIT_BUTTON_CLICK,
                    source: sourceKey,
                    attributes: {
                        supportTicketId
                    }
                });
            },
            [fireUIEvent, sourceKey]
        );

    const sendRequestAssistanceModalDisplayedTrackEvent = useCallback(
        (isEmpty: boolean, supportTicketCount: number) => {
            fireTrackEvent({
                action: ActionKey.DISPLAYED,
                actionSubject: ActionSubjectKey.MODAL,
                actionSubjectId:
                    ActionSubjectIdKey.REQUEST_FASTSHIFT_ASSISTANCE_MODAL,
                source: sourceKey,
                attributes: {
                    isEmpty,
                    supportTicketCount
                }
            });
        },
        [fireTrackEvent, sourceKey]
    );

    const sendPostCommentOutcomeFlagDisplayedTrackEvent = useCallback(
        (successFlag: boolean, supportTicketId: string) => {
            fireTrackEvent({
                action: ActionKey.DISPLAYED,
                actionSubject: ActionSubjectKey.FLAG,
                actionSubjectId:
                    ActionSubjectIdKey.REQUEST_FASTSHIFT_ASSISTANCE_COMMENT_CONFIRMATION_FLAG,
                source: sourceKey,
                attributes: {
                    successFlag,
                    supportTicketId
                }
            });
        },
        [fireTrackEvent, sourceKey]
    );

    return {
        // UI Events (button clicks)
        sendRequestAssistanceButtonClickUIEvent,
        sendRequestAssistanceModalCommentSubmitButtonClickUIEvent,

        // Track Events (manual triggers)
        sendRequestAssistanceModalDisplayedTrackEvent,
        sendPostCommentOutcomeFlagDisplayedTrackEvent
    };
};
